<template>
  <div class="inner">
    <EmptyDisplay class="mt-4" :src="surveyImage" alt="Surveys" title="Carrier Survey Results" text="Please choose from one of the carrier surveys below.">
      <div class="tw:mt-8 tw:flex tw:gap-4">
        <v-btn variant="flat" color="primary" to="/carriers/survey/do">Directors &amp; Officers</v-btn>
        <v-btn variant="flat" color="primary" to="/carriers/survey/tl">Reps &amp; Warranties</v-btn>
        <v-btn variant="flat" color="primary" to="/carriers/survey/cyber">Cyber</v-btn>
      </div>
    </EmptyDisplay>
  </div>
</template>

<script>
import EmptyDisplay from '@/components/EmptyDisplay';
import surveyImage from '@/assets/images/survey.svg';

export default {
  name: 'CarrierSurveyList',
  data: () => ({
    surveyImage,
  }),
  components: { EmptyDisplay },
};
</script>